module.exports = __webpack_public_path__ + "img/p1-info.ee413df0.jpg";